import React, { useState } from 'react'
import useCustomStyles from '../../hooks/useCustomStyles'
import { useSelector } from 'react-redux'
import { selectState } from '../../store/slices/themeSlice'
import { ReactComponent as GoldenProfile } from '../../assets/images/Profile Icon gold.svg'

import { customStyles } from '../../assets/styles/customStyles'
import HeaderTabs from '../clients/components/HeaderTabs'
import MultiSelectGrid from '../clients/components/MultySelect'

const ContractDetails: React.FC = () => {
  const { theme } = useSelector(selectState)

  const classes1 = useCustomStyles(customStyles, theme)

  const [selectedTab, setSelectedTab] = useState('contract_details')

  const tabs = [
    { value: 'contract_details', label: 'Contract Details' },
    { value: 'active_licences', label: 'Active Licences' },
    { value: 'pending_licences', label: 'Pending Licences' },
  ]
  const rows = [
    { label: 'Contract', value: 'contracte' },
    { label: 'Reference', value: 'Reference' },
    { label: 'Start Date', value: 'ZIM Connections' },
    { label: 'Expiry Date', value: '#1236789' },
    { label: 'Administrator', value: 'United Kingdom' },
    { label: 'Total Licences', value: 'English' },
  ]

  const itemList = [
    { id: 1, label: 'Advisor View' },
    { id: 2, label: 'FBAR' },
    { id: 3, label: 'Reports ' },
    { id: 4, label: 'Form 8938' },
    { id: 5, label: 'Geo Tracking' },
    { id: 6, label: 'Unlimited Connections' },
  ]
  return (
    <div className={classes1.container}>
      <div className={classes1?.box}>
        <div className={classes1.tableContainer}>
          <h2 className={classes1.header}>CONTRACT DETAILS</h2>
        </div>
        <HeaderTabs
          tabs={tabs}
          selectedTab={selectedTab}
          onSelect={setSelectedTab}
        />
        {selectedTab === 'contract_details' && (
          <div
            style={{
              borderRadius: '8px',
            }}
          >
            <div
              style={{
                background: '#fff',
                padding: 30,
                width: '90%',
              }}
            >
              <GoldenProfile width={75} height={75} />

              <div
                style={{
                  // padding: "0px 10px",
                  minWidth: '50px',
                  maxWidth: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  overflowX: 'auto',
                }}
              >
                <table
                  style={{
                    width: '70%',
                    borderCollapse: 'collapse',
                    padding: '0px ',
                    height: 20,
                  }}
                >
                  <tbody>
                    {rows.map((row, index) => (
                      <tr
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 1 ? '#fff' : ' #F6F6F6', // White for even, red for odd
                          // borderBottom: "1px solid #eee",
                          maxHeight: '10',
                        }}
                      >
                        <td
                          style={{
                            padding: '10px 15px',
                            fontWeight: 'bold',
                            color: '#777',
                            minWidth: '50%',
                            fontFamily: 'Gilroy-Regular',
                            fontSize: 18,
                            textAlign: 'left',
                            //   maxHeight: "10px",
                            verticalAlign: 'middle', // Align text vertically in the center
                          }}
                        >
                          {row.label}
                        </td>
                        <td
                          style={{
                            width: '50%',
                            padding: '10px 15px',
                            color: '#333',
                            fontFamily: 'Gilroy-Regular',
                            fontSize: 18,
                            fontWeight: '400',
                            textAlign: 'left',
                            //   maxHeight: "10px",
                            verticalAlign: 'middle', // Align text vertically in the center
                          }}
                        >
                          {row.value}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <MultiSelectGrid label={'App Features'} items={itemList} />
          </div>
        )}
      </div>
    </div>
  )
}

export default ContractDetails
